export default __webpack_public_path__ + "media/images/features/local_delivery/episode1/LP_04-a577135e6beaea4339936cb37be4b740.jpg";